import { SEARCHLIGHT_SUBMIT } from '@actions/types'


export const submitSearchLight = ({ auth, data }) => ({
  type: SEARCHLIGHT_SUBMIT,
  payload: {
    request: {
      method: 'post',
      url: `launch/${auth.hash}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: data.scenario_id
    }
  }
})
